import { createAction } from 'redux-actions';

import {
  GET_MULTIPLE_CLIENTS_REPORT,
  SET_MULTIPLE_CLIENTS_REPORT_FILTERS,
  CLEAR_MULTIPLE_CLIENTS_REPORT
} from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  getMultipleClientsReport,
  getMultipleClientsReportPending,
  getMultipleClientsReportFulfilled,
  getMultipleClientsReportRejected,
} = createAsyncActions(GET_MULTIPLE_CLIENTS_REPORT, 'getMultipleClientsReport');

export const setMultipleClientsReportSearchFilters = createAction(SET_MULTIPLE_CLIENTS_REPORT_FILTERS);

export const clearMultipleClientsReports = createAction(CLEAR_MULTIPLE_CLIENTS_REPORT);



// WEBPACK FOOTER //
// ./src/features/reports/actions/getMultipleClientsReportActions.js